<app-adminav></app-adminav>
<br><br>
<div class="container">
    <h3>Editar publicación del blog:</h3>
    <hr>
    <br>
    <div class="text-center">
        <small>Fecha de creación: {{post.fecha | date}}</small>
        <br>
        <label><b>Título:</b></label>
        <h3>{{post.titulo}}</h3>
        <input class="form-control" type="text" placeholder="Ingrese nuevo título" [(ngModel)]="title">
        <br>
        <div *ngIf="post.video == 'Si'">
            <label><b>Url del video:</b></label>
            <p><b>{{post.imagen}}</b></p>
            <input class="form-control" type="text" placeholder="Ingrese la nueva URL del video" [(ngModel)]="urlVideo">
        </div>
        <div *ngIf="post.video == 'No'">
          <img *ngIf="!urlImage1" [src]="post.imagen" width="200" alt="">
          <img *ngIf="urlImage1" [src]="urlImage1" width="200" alt="">
          <br>
          <div class="progress">
            <div class="progress-bar progress-bar-striped bg-success" role="progressbar" [style.width]="(uploadPercent1 | async) + '%'"></div>
         </div>
          <label>Cambiar imagen:</label>
          <br>
          <input type="file" (change)="handleImage1($event)">
        </div>
    </div>
    <div>
        <label><b>Introducción:</b></label>
        <p>{{post.introduccion}}</p>
        <textarea class="form-control" cols="30" rows="3" [(ngModel)]="intro" placeholder="Ingrese la nueva introducción"></textarea>
    </div>
    <div> 
        <label><b>Agregar Párrafo al contenido:</b></label>
        <textarea class="form-control" cols="30" rows="5" [(ngModel)]="parrafo"></textarea> 
        <button class="btn btn-primary mt-1 mb-2" (click)="agregarParrafo()">Agregar Párrafo</button>      
        <table class="table">
            <thead>
                <tr>
                  <th><b>Contenido</b></th>
                  <th><b>Acciones</b></th>
                </tr>
              </thead>
           <tbody>
              <tr *ngFor="let item of post.contenido; let i = index">
                <td>
                   <p>{{item}}</p>
                </td>
                <td>
                    <button class="btn btn-danger" (click)="borrarParrafo(i)"><i class="fa fa-trash"></i></button>
                </td>
              </tr>                    
            </tbody>
          </table>
    </div>
    <br>
    <button (click)="verObjeto()" data-toggle="modal" data-target="#exampleModal">Ver objeto</button>
</div>

<div *ngIf="post" class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Detalle del artículo</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
            </div>
            <div class="modal-body" style="background-color: #fff;">
                <div class="card mb-3">
                  <div *ngIf="post.video == 'Si'" class="text-center">
                    <iframe width="560" height="315" [src]="getVideoIframe(post.imagen)" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                  </div>
                    <img *ngIf="post.video == 'No'" [src]="post.imagen" class="card-img-top" alt="...">
                    <div class="card-body">
                        <h5 class="card-title">{{post.titulo}}</h5>
                        <p *ngFor="let item of post.contenido" class="card-text">{{item}}</p>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                <button type="button" class="btn btn-primary" (click)="actualizarBlog()" data-dismiss="modal">Guardar cambios</button>
            </div>
        </div>
    </div>
</div>